import React, { useContext } from 'react'
import styled from 'styled-components'
import GatsbyImage from 'gatsby-image'
import { LayoutContext } from '../../contexts'
import { SiteLink } from '../shared/SiteLink'
import { useBlogpageHeroClickedTracking } from '../../hooks/tracking'
import { useGlobal } from '../../hooks/useGlobal'

const BlogHero = ({
  featuredBlogpostImage,
  featuredBlogpost,
  whiteTitle,
  location,
}) => {
  const { currency, node_locale } = useContext(LayoutContext)

  const {
    layout: { readMore },
  } = useGlobal(['layout'], node_locale)

  return (
    <StyledBlogHero>
      <StyledImage
        fluid={featuredBlogpostImage.fluid}
        alt={featuredBlogpostImage.title}
        withPlaceholder
      />
      <Wrapper>
        <div>
          <Label>{featuredBlogpost.type}</Label>
          <Header whiteTitle={whiteTitle}>{featuredBlogpost.title}</Header>
          <Button
            to={featuredBlogpost.slug}
            onClick={() =>
              useBlogpageHeroClickedTracking({
                currency: currency?.code,
                locale: node_locale,
                linkType: 'Button',
                label: readMore,
                title: featuredBlogpost.title,
                destination: `/${node_locale}/${featuredBlogpost.slug}/`,
              })
            }
            state={{ referrer: location.pathname }}
          >
            {readMore}
          </Button>
        </div>
      </Wrapper>
    </StyledBlogHero>
  )
}

const StyledBlogHero = styled.section`
  position: relative;
  flex-direction: column;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 100vh;
  }
`

const StyledImage = styled(GatsbyImage)`
  width: 100%;
  object-fit: cover;
  display: flex;
  height: 125vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 100%;
  }
`

const Wrapper = styled.div`
  padding: ${(props) => props.theme.space.marginMobile * 2}vw
    ${(props) => props.theme.space.marginMobile * 4}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: 0 ${(props) => props.theme.space.marginDesktop * 10}vw;
    max-width: 40vw;
    position: absolute;
    display: flex;
    align-items: center;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`

const Label = styled.div`
  font-size: 2.93333vw;
  display: inline-block;
  background: ${(props) => props.theme.colors.blue};
  text-align: center;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: ${(props) => props.theme.space.marginMobile / 2}vw
    ${(props) => props.theme.space.marginMobile / 2}vw;
  margin-bottom: ${(props) => props.theme.space.marginMobile / 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d12};
    padding: ${(props) => props.theme.space.marginDesktop}vw
      ${(props) => props.theme.space.marginDesktop}vw;
    margin-bottom: ${(props) => props.theme.space.marginDesktop}vw;
  }
`

const Header = styled.h1`
  font-size: 7.3333vw;
  margin-bottom: ${(props) => props.theme.space.marginMobile}vw;
  line-height: 8.66666666vw;
  color: '#000';

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 3.125vw;
    line-height: 3.8194vw;
    margin-bottom: ${(props) => props.theme.space.marginDesktop * 2}vw;
    color: ${(props) => (props.whiteTitle ? '#fff' : '#000')};
  }
`

const Button = styled(SiteLink)`
  display: inline-block;
  background: ${(props) => props.theme.colors.blue};
  font-size: ${(props) => props.theme.fontSize.m26};
  text-align: center;
  color: white;
  padding: ${(props) => props.theme.space.marginMobile * 1.2}vw
    ${(props) => props.theme.space.marginMobile * 2.5}vw;
  font-family: ${(props) => props.theme.fontFamily.medium};
  letter-spacing: 0.05em;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: ${(props) => props.theme.fontSize.d14};
    color: black;
    background: white;
    padding: ${(props) => props.theme.space.marginDesktop * 2}vw
      ${(props) => props.theme.space.marginDesktop * 4}vw;
    width: fit-content;
  }
`

export default BlogHero
